/**
 * Theme component overrides.
 *
 * Each component's styling lives in the theme rather than in per-call-site `sx`,
 * so instances stay consistent without wrapper components. Scoped to the
 * components this form actually renders.
 */

import type { Components, Theme } from '@mui/material/styles'

import { MuiAlertOverride } from './MuiAlert.override'
import { MuiButtonOverride } from './MuiButton.override'
import { MuiPaperOverride } from './MuiPaper.override'
import { MuiTextFieldOverride } from './MuiTextField.override'

export const componentOverrides: Components<Theme> = {
  MuiAlert: MuiAlertOverride,
  MuiButton: MuiButtonOverride,
  MuiPaper: MuiPaperOverride,
  MuiTextField: MuiTextFieldOverride
}
